(() => {
    const components = document.querySelectorAll(`[data-component="share-tools"]`);

    if (components.length) {
        let title;

        if (!window.location.href.match(/link-group.html/g)) title = document.head.querySelector(`[name="dcterms.title"]`).getAttribute("content");
        else title = "Page title";

        [ ...components ].forEach(cmp => {
            const print = cmp.querySelector(`[data-role="print-page"]`);
            const email = cmp.querySelector(`[data-role="share-via-email"]`);

            print.addEventListener("click", () => {
                window.print();
            });

            // email sharing
            email.href = `mailto:?subject=${ title }&body=${ encodeURIComponent(window.location.href) }`;
        });
    }
})();
